import NoticeListContainer from './NoticeListContainer';
export default NoticeListContainer;
